import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { addCommas, numberToWords } from "@persian-tools/persian-tools";
import ModalLayout from "../../../../../../components/ModalLayout";
import ArrowUpFillType3SVG from "../../../../../../../media/images/icons/arrow-up-typ3";
import PriceInput from "./PriceInput";
import CustomButton from "../../../../../../components/CustomButton";
import CloseCircleSVG from "../../../../../../../media/images/icons/close-icon";
import RowsIcon from "../../../../../../../media/images/icons/rows-icons";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
  setSnackbarChildren,
} from "../../../../../../../redux/features/snackbarSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../hooks/useRedux";
import { useNavigate } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../../media/images/icons/arrow-left";

interface Props {
  open: boolean;
  handleClose: () => void;
  orderId: string;
}
export default function TenderOfferModal({
  handleClose,
  open,
  orderId,
}: Props) {
  const theme = useTheme();

  const [priceValue, setPriceValue] = useState("");
  const [priceWord, setPriceWord] = useState<string | TypeError>("");
  const [lastOfferValue, setLastOfferValue] = useState("");

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { salonInfo, nobatCode, nobatDate } = useAppSelector(
    (state) => state.user.driverNobatQueueInfo
  );
  const formik = useFormik({
    initialValues: {
      orderId: "",
      price: "",
    },
    validationSchema: yup.object().shape({
      price: yup.string().required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      postTenderOffer({
        price: Number(values.price),
        orderId: orderId,
      });
      // .catch((e) => {
      //   dispatch(setOpenSnackbar(true));
      //   dispatch(setSnackbarErrorStatus(e.response.data.errorCode));
      //   dispatch(setSnackbarDescription(e.response.data.error));
      //   if (!salonInfo)
      //     dispatch(
      //       setSnackbarChildren(
      //         <CustomButton
      //           flex={1}
      //           // loading={true}
      //           flexDirection="row-reverse"
      //           justifyContent="center"
      //           onClick={() => {
      //             navigate("../check-in");
      //             dispatch(setOpenSnackbar(false));
      //           }}
      //           title="اعلام حضور"
      //           bgColor="primary.main"
      //           textColor="#fff"
      //           fWeight="700"
      //           px="10px"
      //           py="12px"
      //           mt="12px"
      //           borderRadius="10px"
      //           icon1={<ArrowLeftSVG size={26} color={"#fff"} />}
      //         />
      //       )
      //     );
      // });
    },
  });

  const handleChangePrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;
    if (value.startsWith("0") && value.length > 1 && value[1] !== ".") {
      value = value.slice(1);
    }
    const numericValue = value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const formattedValue = addCommas(numericValue); // Format the value with commas
    formik.setFieldValue("price", numericValue); // Update Formik's field value
    setPriceValue(formattedValue);
    setPriceWord(numberToWords(String(Math.trunc(Number(numericValue) / 10))));
  };

  const { trigger: postTenderOffer, isMutating: isPostTenderOfferMutting } =
    useSWRMutation(
      [`/DriverPriceReq/Insert`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          formik.resetForm();
          setPriceValue("");
          handleClose();
        },
      }
    );

  const {
    data: getLastTenderOfferData,
    trigger: getLastTenderOffer,
    isMutating: isgetLastTenderOfferMutting,
  } = useSWRMutation(
    [`/DriverPriceReq/Get`, localStorage.getItem("access_token")],
    fetcherPost
  );

  useEffect(() => {
    if (open) {
      getLastTenderOffer({
        orderId,
      });
    } else {
      setPriceValue("");
    }
  }, [open]);

  useEffect(() => {
    if (getLastTenderOfferData) {
      setLastOfferValue(getLastTenderOfferData.price);
    }
  }, [getLastTenderOfferData]);

  return (
    <ModalLayout open={open} setOpen={handleClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          <RowsIcon color={theme.palette.secondary.main} />
          <Typography
            color={"secondary.main"}
            sx={{
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            مناقصه بار{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {lastOfferValue && (
            <Box
              sx={{
                backgroundColor: theme.palette.secondary[50],
                borderRadius: "8px",
                display: "flex",
                paddingX: "8px",
                paddingY: "12px",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ArrowUpFillType3SVG color={theme.palette.secondary[600]} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  color={theme.palette.secondary[600]}
                >
                  آخرین کرایه پیشنهادی شما:
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                  }}
                  color={theme.palette.secondary[600]}
                >
                  {addCommas(lastOfferValue)}
                </Typography>
                <Typography
                  color="secondary.main"
                  sx={{
                    fontWeight: "700",
                    fontSize: "12px",
                  }}
                >
                  ریال
                </Typography>
              </Box>
            </Box>
          )}
          <Typography
            textAlign={"center"}
            sx={{
              fontSize: "14px",
              fontWeight: "700",
            }}
            color={"primary.main"}
          >
            کرایه پیشنهادی خود را وارد کنید
          </Typography>
          {/* <Typography
            textAlign={"center"}
            sx={{
              fontSize: "14px",
              fontWeight: "700",
            }}
            color={"primary.main"}
          >
            کرایه پیشنهادی جدید خود را وارد کنید
          </Typography> */}
          <PriceInput
            handleChangeInput={handleChangePrice}
            name="price"
            value={priceValue}
            error={formik.touched.price && Boolean(formik.errors.price)}
          />
          {priceValue.length > 1 && (
            <Typography
              sx={{
                mb: 1,
                fontSize: "12px",
              }}
            >
              {priceWord.toString() + " " + "تومان"}
            </Typography>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <CustomButton
              flex={1}
              // loading={true}
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => formik.handleSubmit()}
              title="ارسال پیشنهاد"
              bgColor="primary.main"
              textColor="#fff"
              fWeight="700"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={<ArrowUpFillType3SVG size={26} color={"#fff"} />}
            />
            <CustomButton
              type="outlined"
              rippleColor={theme.palette.primary.main}
              // loading
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => handleClose()}
              title="انصراف"
              fWeight="700"
              bgColor={theme.palette.primary[50]}
              textColor="primary.main"
              borderColor="primary.main"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={
                <CloseCircleSVG size={26} color={theme.palette.primary.main} />
              }
            />
          </Box>
        </Box>
      </Box>
    </ModalLayout>
  );
}
